module.exports = __webpack_public_path__ + "img/pb-logo-white.46396551.png";